import { createReducer } from "../../../common/reduxUtil";
import { DMAT_SET_TOUR, DMAT_SET_OFFLINE } from "./types";

const initialState = {
  tour: false,
  offline: false,
};

export default createReducer(initialState, {
  [DMAT_SET_TOUR]: (state, tour) => ({ ...state, tour }),
  [DMAT_SET_OFFLINE]: (state, offline) => ({ ...state, offline }),
});
